<div class="feature-importance-wrapper" id="feature-importance-accordion">
  <mat-accordion>
    <mat-expansion-panel #featureImportancePanel>
      <mat-expansion-panel-header
        data-cy="feature-importance-expansion-panel-header"
      >
        <mat-panel-title>
          {{ 'RESULT.IMPORTANCE.HEADLINE' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <highcharts-chart
        id="feature-chart"
        [(update)]="chartUpdated"
        (chartInstance)="setChartInstance($event)"
        [oneToOne]="true"
        [options]="chartOptions"
      >
      </highcharts-chart>
      <mat-card appearance="outlined" class="mt-10">
        <mat-card-content class="bg-gray-100 text-xs">
          {{ 'RESULT.IMPORTANCE.BODY' | translate }}
        </mat-card-content>
      </mat-card>
    </mat-expansion-panel>
  </mat-accordion>
</div>
